import React from 'react';
import { useFocusManagement } from '../../hooks/useFocusManagement';

interface FocusManagerProps {
  children: React.ReactNode;
}

/**
 * Component that manages focus on route changes
 * Wraps the application to provide focus management
 */
const FocusManager: React.FC<FocusManagerProps> = ({ children }) => {
  // Use focus management with default options
  useFocusManagement({
    focusTarget: 'main, [role="main"], h1',
    focusDelay: 100,
    announcePageTitle: true,
    skipPaths: ['/login'], // Skip focus management on login page
  });

  return <>{children}</>;
};

export default FocusManager;